"use client";
import React from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import Image from "next/image";
import { IMAGES } from "../constants/images";
import { useTranslation } from "react-i18next";

export default function ZaynQuoteTestimonial() {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 2,
        mt: "1%",
        mb: "2%",
        direction: isArabic ? "rtl" : "ltr",
      }}
    >
      <Card
        sx={{
          maxWidth: 830,
          position: "relative",
          overflow: "visible",
          border: "none",
          boxShadow: "none",
          width: { xs: "100%", sm: "90%", md: "90%", lg: "auto" },
        }}
      >
        <CardContent
          sx={{
            padding: { xs: 2, sm: 3, md: 4 },
            display: "flex",
            gap: { xs: 2, sm: 3 },
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "flex-start", sm: "center" },
          }}
        >
          {/* Avatar */}
          <Box
            sx={{
              position: "relative",
              width: { xs: 70, sm: 80, md: 120 },
              height: { xs: 70, sm: 80, md: 123 },
              overflow: "hidden",
              flexShrink: 0,
              alignSelf: { xs: "center", sm: "flex-start" },
              mt: "1%",
            }}
          >
            <Image src={IMAGES.SAJID_TESTIMONIAL_AVATAR} alt="Sajid" fill />
          </Box>

          {/* Content */}
          <Box
            sx={{
              flex: 1,
              position: "relative",
              textAlign: isArabic ? "right" : "left",
              ml: isArabic ? 0 : { xs: 1, sm: 0 },
              mr: isArabic ? { xs: 1, sm: 0 } : 0,
            }}
          >
            {/* Top Quote Image */}
            <Box
              sx={{
                position: "absolute",
                top: { xs: -15, sm: -20, md: -46 },
                left: isArabic ? "unset" : { xs: -10, sm: -15, md: -60 },
                right: isArabic ? { xs: -10, sm: -15, md: -60 } : "unset",
                opacity: 0.6,
                display: { xs: "none", sm: "block" },
                transform: isArabic ? "scaleX(-1)" : "none",
              }}
            >
              <Image
                src={IMAGES.TOP_QUOTE}
                alt="Top Quote"
                width={150}
                height={150}
                style={{ objectFit: "contain" }}
              />
            </Box>

            {/* Testimonial Text */}
            <Typography
              sx={{
                fontSize: { xs: "15px", sm: "17px", md: "18px", lg: "23.5px" },
                color: "#000000",
                marginBottom: 1,
                fontWeight: 400,
                fontFamily: "var(--font-outfit)",
                lineHeight: "1.3",
                textAlign: isArabic ? "right" : "left",
                mx: { xs: "5%", sm: "3%", md: 0, lg: "6%" },
                mt: { xs: "10%", sm: "10%", md: 0, lg: 0 },
              }}
            >
              {t("zaynQuoteTestimonial.quote")}
            </Typography>

            {/* Role */}
            <Typography
              variant="caption"
              sx={{
                display: "block",
                fontSize: { xs: "0.85rem", sm: "0.9rem", md: "1rem" },
                color: "#8C99A2",
                fontFamily: "var(--font-outfit)",
                fontWeight: 400,
                textAlign: isArabic ? "right" : "left",
                mx: { xs: "5%", sm: "3%", md: 0, lg: "6%" },
              }}
            >
              {t("zaynQuoteTestimonial.role")}
            </Typography>

            {/* Bottom Quote Image */}
            <Box
              sx={{
                position: "absolute",
                bottom: { xs: -5, sm: -8, md: -3 },
                right: isArabic ? "unset" : { xs: -5, sm: -8, md: -10 },
                left: isArabic ? { xs: -5, sm: -8, md: -10 } : "unset",
                opacity: 0.6,
                display: { xs: "none", sm: "block" },
                transform: isArabic ? "scaleX(-1)" : "none",
              }}
            >
              <Image
                src={IMAGES.BOTTOM_QUOTE}
                alt="Bottom Quote"
                width={150}
                height={150}
                style={{ objectFit: "contain" }}
              />
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
